import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    editEmployee,
    fetchEmployee,
    getEmployees,
} from '../../app/reducers/Users/EmployeeSlice';
import { useFormik } from 'formik';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { ClipLoader } from 'react-spinners';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { object, string } from 'yup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import FormikCheckbox from '../../components/formik/FormikCheckbox';
import {
    fetchDispatchLocations,
    getDispatchLocation,
} from '../../app/reducers/DispatchLocation/dispatchLocationSlice';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import { generateOptions } from '../../utils/Utils';
import { ROLES } from '../../utils/dropdownOptions';
import { getAuth } from '../../app/reducers/Auth/authSlice';

const EditEmployeePage = () => {
    const { id } = useParams();
    const { user } = useSelector(getAuth);
    const dispatch = useDispatch();
    const { elementEditData, elementEditDataLoading } =
        useSelector(getEmployees);
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(fetchEmployee({ _id: id }));
    }, []);

    const { dispatchLocation } = useSelector(getDispatchLocation);

    useEffect(() => {
        dispatch(fetchDispatchLocations());
    }, []);

    const dispatchLocationData = useMemo(
        () => (dispatchLocation.docs ? dispatchLocation.docs : []),
        [dispatchLocation.docs]
    );

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...elementEditData,
            password: '',
        },
        validationSchema: object({
            firstName: string().required(),
            username: string().required(),
        }),
        onSubmit: async (values) => {
            console.log(values);
            await dispatch(editEmployee(values));
            navigate("/users/view-employee");
        },
    });
    return (
        <PageWithCard heading='Edit Employee'>
            {elementEditDataLoading ? (
                <ClipLoader />
            ) : (
                <form
                    onSubmit={formik.handleSubmit}
                    className="flex flex-col gap-4"
                >
                    <FormikInputGroup
                        label="System Id"
                        name="_id"
                        required
                        readOnly
                        formik={formik}
                    />
                    <FormikInputGroup
                        label="Phone"
                        name="username"
                        required
                        readOnly
                        formik={formik}
                    />
                    <FormikInputGroup
                        label="First Name"
                        name="firstName"
                        required
                        formik={formik}
                    />
                    <FormikInputGroup
                        label="Last Name"
                        name="lastName"
                        formik={formik}
                    />
                    <FormikSelectGroup
                        label="Dispatch Location"
                        name="location"
                        formik={formik}
                        options={generateOptions({
                            array: dispatchLocationData ?? [],
                            labelField: 'name',
                            valueField: '_id',
                        })}
                    />
                    <FormikSelectGroup
                        label="Role"
                        name="role"
                        formik={formik}
                        options={generateOptions({
                            array:
                                user?.role === 'sup_admin'
                                    ? ROLES
                                    : ROLES?.filter(
                                        (el) => el.value !== 'sup_admin'
                                    ),
                            labelField: 'label',
                            valueField: 'value',
                        })}
                    />
                    {/* <FormikInputGroup
                        label="Password"
                        name="password"
                        type="password"
                        formik={formik}
                    /> */}
                    <FormikCheckbox
                        label="Status"
                        name="status"
                        formik={formik}
                    />
                    <div>
                        <PrimaryButton type="submit">Submit</PrimaryButton>
                    </div>
                </form>
            )}
        </PageWithCard>
    );
};

export default EditEmployeePage;
